import apiWrapper from 'Helpers/apiWrapper'

const endpoints = ((baseURL) => {
  return {
    automationSending: (idSending) =>
      `${baseURL}/api/automation/sending/${encodeURIComponent(
        idSending,
      )}/email`,
    automationSmsSending: (idSending) =>
      `${baseURL}/api/automation/sending/${encodeURIComponent(idSending)}/sms`,
    // Checks
    getSentEmailItemDetail: (idSending) =>
      `${baseURL}/api/automation/sending/${encodeURIComponent(
        idSending,
      )}/email`,
    getSentSMSItemDetail: (idSending) =>
      `${baseURL}/api/automation/sending/${encodeURIComponent(idSending)}/sms`,
  }
})(process.env.BEAUTOMATION_URL)

export const beAutomationSending = (idSending) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.automationSending(idSending),
  }).then(({ data }) => data)
}

export const beAutomationSmsSending = (idSending) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.automationSmsSending(idSending),
  }).then(({ data }) => data)
}

export const beAutomationGetSentEmailItemDetail = (idSending) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getSentEmailItemDetail(idSending),
  }).then(({ data }) => data)
}
export const beAutomationGetSentSMSItemDetail = (idSending) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getSentSMSItemDetail(idSending),
  }).then(({ data }) => data)
}
